import { AdminAppState } from '../../state';
import { getSiteViewportState } from './get-site-viewport-state';

export const getSiteViewportFullscreen = (state: AdminAppState): boolean =>
  getSiteViewportState(state).fullscreen;
